import React from 'react'

import pic1 from '../assets/source1.png'
import pic2 from '../assets/protected.png'
import pic3 from '../assets/source3.png'
function Gallery() {
    // const galleryobj=[{
    //     img:"https://dummyimage.com/600x360",
    // },{},{},{},{},{}];
  return (
    <>
<section className="text-gray-400 bg-slate-200 body-font">
  <div className="container px-5 py-24 mx-auto">
  <div className="flex flex-col text-center w-full mb-20">
  <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-richblack-900">Blockchain Technology</h1>
  <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
    Blockchain technology offers numerous advantages such as transparency, security, and decentralization. Unlike traditional centralized systems, blockchain ensures trust and immutability through its distributed ledger mechanism. With blockchain, transactions can be securely recorded and verified, reducing the risk of fraud and manipulation. Furthermore, blockchain's decentralized nature eliminates the need for intermediaries, resulting in faster and more cost-effective transactions.
  </p>
</div>


    <div className="flex flex-wrap -m-4">
  <div className="lg:w-1/3 sm:w-1/2 p-4">
    <div className="flex relative">
      <img alt="gallery" className="absolute inset-0 w-full h-full object-cover object-center" src={pic1}/>
      <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
        <h2 className="tracking-widest text-sm title-font font-medium text-blue-400 mb-1">DECENTRALIZATION</h2>
        <h1 className="title-font text-lg font-medium text-white mb-3">Empowering Individuals</h1>
        <p className="leading-relaxed">Blockchain enables decentralization, giving individuals control over their data and transactions without the need for intermediaries.</p>
      </div>
    </div>
  </div>
  <div className="lg:w-1/3 sm:w-1/2 p-4">
    <div className="flex relative">
      <img alt="gallery" className="absolute inset-0 w-full h-full object-cover object-center" src={pic2}/>
      <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
        <h2 className="tracking-widest text-sm title-font font-medium text-blue-400 mb-1">SMART CONTRACTS</h2>
        <h1 className="title-font text-lg font-medium text-white mb-3">Efficient Automation</h1>
        <p className="leading-relaxed">Smart contracts automate and execute agreements automatically, reducing the need for manual processes and intermediaries.</p>
      </div>
    </div>
  </div>
  <div className="lg:w-1/3 sm:w-1/2 p-4">
    <div className="flex relative">
      <img alt="gallery" className="absolute inset-0 w-full h-full object-cover object-center" src={pic3}/>
      <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
        <h2 className="tracking-widest text-sm title-font font-medium text-blue-400 mb-1">TOKENIZATION</h2>
        <h1 className="title-font text-lg font-medium text-white mb-3">Enhanced Security</h1>
        <p className="leading-relaxed">Tokenization of assets enhances security, enabling fractional ownership and efficient trading of digital assets.</p>
      </div>
    </div>
  </div>
</div>

  </div>
</section>
</>
  )
};
export default Gallery;